// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 581 ? "main.app" : chunkId) + "." + {"581":"cecb3520","994":"916b3b1e"}[chunkId] + ".chunk.js";
};